// extracted by mini-css-extract-plugin
export default {"quantity":"i1I8CE","mobileQuantity":"IsLUPC"};